function SearchResults( { products, setProducts, setCartPreviewItems, setSearchTerm, setNoticeContent, setAddingToCartPreview } ) {
	const { swiftCartTranslations } = window.QalaB2bWholesale.translations;

	const handleAddToCartPreview = async product => {
		setProducts( [] );
		setSearchTerm( '' );
		setAddingToCartPreview( true );
		setNoticeContent( {
			message: '',
			type: '',
		} );

		const newProduct = {
			id: product.object_id,
			sku: product.sku,
			title: product.title,
			priceHtml: product.price_html,
			image_url: product.image_url,
			url: product.url,
			quantity: 1,
			stock: product.stock_quantity,
			hasError: false,
			isReplaced: false,
		};

		const { _wpnonce } = window.QalaB2bWholesale.swiftCartObj;

		try {
			const response = await fetch( '/wp-json/qala-b2b-wholesale/v1/swift-cart/validate-product', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': _wpnonce,
				},
				body: JSON.stringify( {
					product_id: product.object_id,
				} ),
			} );

			const jsonBody = await response.json();

			if ( response.ok ) {
				const replacedProductResponse = await fetch( '/wp-json/qala-b2b-wholesale/v1/swift-cart/replaced-product', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce': _wpnonce,
					},
					body: JSON.stringify( {
						product_id: product.object_id,
					} ),
				} );

				const replacedProductJsonBody = await replacedProductResponse.json();

				if ( replacedProductJsonBody ) {
					newProduct.id = replacedProductJsonBody.id.toString();
					newProduct.sku = replacedProductJsonBody.sku;
					newProduct.title = replacedProductJsonBody.title;
					newProduct.priceHtml = replacedProductJsonBody.price_html;
					newProduct.image_url = replacedProductJsonBody.image_url;
					newProduct.url = replacedProductJsonBody.url;
					newProduct.stock = replacedProductJsonBody.stock_quantity;
					newProduct.isReplaced = true;
				}

				setCartPreviewItems( prevState => {
					const productExists = prevState.find( item => item.id === newProduct.id );
					return productExists ? prevState : [ ...prevState, newProduct ];
				} );
			} else {
				setNoticeContent( {
					message: jsonBody.message,
					type: 'error',
				} );
			}
		} catch ( e ) {
			setNoticeContent( {
				message: swiftCartTranslations.genericError,
				type: 'error',
			} );
		}

		setAddingToCartPreview( false );
	};

	return <>
		{ products.length > 0 && <ul className="qala-b2b-wholesale-swift-cart-search-results">
			{ products.map( product =>
				<li
					key={ product.id }
					onClick={ () => handleAddToCartPreview( product ) }
					onKeyUp={ keyCode => keyCode.code === 'Enter' && handleAddToCartPreview( product ) }
					tabIndex={ 0 }
					role="button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
				>
					<div className="qala-b2b-wholesale-swift-cart-search-results-details">
						<div className="qala-b2b-wholesale-swift-cart-search-results-details-image" dangerouslySetInnerHTML={ { __html: product.image_html } } />
						<div className="qala-b2b-wholesale-swift-cart-search-results-details-title">{ product.title } ({ product.sku })</div>
					</div>
					<div>{ product.stock_quantity } { swiftCartTranslations.inStock }</div>
				</li>
			) }
		</ul> }
	</>;
}

export default SearchResults;
